import React from 'react';
import { Shield, Settings, Phone, MessageCircle } from 'lucide-react';
import GoogleRatingBadge from './GoogleRatingBadge';
import { CallbackButton, SAC_PHONE_DISPLAY, SAC_PHONE_TEL } from './CallbackModal';

const Footer = ({ onOpenPrivacyPolicy, onOpenAdmin }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <img 
              src="./fernando-tech-logo.png" 
              alt="Fernando Tech Logo" 
              className="h-12 w-12 object-contain rounded-lg"
            />
            <div className="flex flex-col">
              <span className="text-white font-bold text-lg">Fernando Tech</span>
              <span className="text-blue-300 text-xs">Suporte Premium</span>
            </div>
          </div>
          <GoogleRatingBadge />
        </div>

        {/* Contato: SAC fixo + WhatsApp + Me ligue agora */}
        <div className="mt-6 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-testid="footer-contact">
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-5">
            <a
              href={SAC_PHONE_TEL}
              className="inline-flex items-center gap-2 text-white hover:text-cyan-300 font-semibold text-sm transition-colors"
              data-testid="footer-sac-phone"
            >
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-cyan-500/10 border border-cyan-500/30">
                <Phone className="w-4 h-4 text-cyan-400" />
              </span>
              <span className="flex flex-col leading-tight">
                <span>SAC {SAC_PHONE_DISPLAY} <span className="text-slate-400 font-normal">· Opção 1</span></span>
                <span className="text-[11px] text-slate-500 font-normal">Seg–Sex 8h–18h · Sáb 8h–12h</span>
              </span>
            </a>
            <a
              href="https://wa.me/5516991378312?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white hover:text-emerald-300 font-semibold text-sm transition-colors"
              data-testid="footer-whatsapp"
            >
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-emerald-500/10 border border-emerald-500/30">
                <MessageCircle className="w-4 h-4 text-emerald-400" />
              </span>
              WhatsApp (16) 99137-8312
            </a>
          </div>
          <div className="flex flex-col items-center md:items-end gap-1">
            <CallbackButton testId="footer-callback-open" />
            <span className="text-[11px] text-slate-500">A Fernando Tech entra em contato com você</span>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-slate-800">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <button
              onClick={onOpenPrivacyPolicy}
              className="text-cyan-400 hover:text-cyan-300 text-sm flex items-center gap-1 transition-colors"
            >
              <Shield className="w-4 h-4" />
              Política de Privacidade
            </button>
            <span className="text-gray-600">|</span>
            <span className="text-gray-400 text-sm">LGPD Compliant</span>
            {onOpenAdmin && (
              <>
                <span className="text-gray-600">|</span>
                <button
                  onClick={onOpenAdmin}
                  className="text-gray-500 hover:text-cyan-400 text-sm flex items-center gap-1 transition-colors"
                  title="Painel Administrativo"
                >
                  <Settings className="w-4 h-4" />
                  Admin
                </button>
              </>
            )}
          </div>

          <div className="text-center">
            <p className="text-gray-400 text-sm">
              &copy; Desde 2008 | {currentYear} Fernando Tech Soluções. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-xs mt-2">
              Fotos meramente ilustrativas.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
